import { Component, Input, AfterViewInit, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
  selector: "app-percentage-input",
  templateUrl: "percentage-input.html",
})
export class PercentageInputComponent implements AfterViewInit {

  @ViewChild("range") public range: any;
  @Input() public color = "tertiary";
  @Input() public control: FormControl;
  @Input() public label = "Tax";
  @Input() public max = 100;
  @Input() public min = 0;
  @Input() public pin = true;
  @Input() public snaps = false;
  @Input() public step = 1;

  public ngAfterViewInit() {
    this.range.value = this.control.value * 100;
  }

  public valueChange({ value }) {
    this.control.setValue(value / 100);
  }

}



// WEBPACK FOOTER //
// ./src/components/percentage-input/percentage-input.ts